// extracted by mini-css-extract-plugin
export default {"toursHeadline":"BookTour_toursHeadline__v8-t7","globeCaption":"BookTour_globeCaption__L9KqV","toursParagraph":"BookTour_toursParagraph__XY+yP"};